import styled from 'styled-components'

export const ContainerAtribuicao = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 5px;
  overflow: hidden;
`
